export const isValidEmailAddress = (emailAddress: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (emailAddress && emailRegex.test(emailAddress)) {
    return true
  }
  return false
}
